<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';
import i18n from '@/localization/i18n';
import { navigate } from 'vike/client/router';
import Link from '@/views/components/Link.vue';
import 'vue3-carousel/dist/carousel.css'
import {Carousel, Slide} from "vue3-carousel";

const VITE_ASSET_URL = import.meta.env.VITE_ASSET_URL

const t = i18n.global.t 

let activeSlide = ref(0)
const slideItemsPerPage = ref(3)
const isClient = ref(false)

const checkScreenSize = () => {
  if (window.innerWidth <= 600) {
    slideItemsPerPage.value = 1
  } else if (window.innerWidth >= 600 && window.innerWidth <= 992) {
    slideItemsPerPage.value = 2
  } else if (window.innerWidth > 992) {
    slideItemsPerPage.value = 3
  }
}

onMounted(() => {
  isClient.value = true
  checkScreenSize()
  window.addEventListener('resize', checkScreenSize)
})

onUnmounted(() => {
  window.removeEventListener('resize', checkScreenSize)
})


const articles = ref([
    {
       id: 4,
        title: 'Trouvez un carreleur pour vos travaux de rénovation',
        description: "Trouvez un carreleur qualifié pour vos travaux de rénovation avec Topela. Obtenez des devis gratuits et comparez les professionnels près de chez vous.",
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/16x5-trouvez-carreleur.webp`,
        category: 'Conseils',
        path: '/blog/particuliers/trouvez-un-carreleur/',
        publish_date: '15/10/2025'
    },
    {
        id: 5,
        title: 'Trouvez un peintre pour vos travaux de rénovation',
        description: "Trouvez un peintre qualifié pour vos travaux de rénovation avec Topela. Obtenez des devis gratuits et comparez les professionnels près de chez vous.",
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/16x5-trouvez-peintre.webp`,
        category: 'Conseils',
        path: '/blog/particuliers/trouvez-un-peintre/',
        publish_date: '15/11/2025'
    },
    {
        id: 6,
        title: 'Trouvez un électricien pour vos petits travaux',
        description: "Trouvez un électricien fiable pour vos petits travaux électriques avec Topela. Comparez les devis gratuits et choisissez le professionnel adapté à vos besoins.",
        image: `${VITE_ASSET_URL}assets/public/assets/img/blog/16x5-trouvez-electricien.webp`,
        category: 'Conseils',
        path: '/blog/particuliers/trouvez-un-electricien/',
        publish_date: '01/12/2025'
    }
])

const navigate_to_article = async (path: string) => {
    await navigate(path)
}
</script>

<template>
    <div id="cs-blog" class="my-5">
        <div class="container">
            <h2 class="h-style h2-style use-poppins text-center mb-5">
                {{ t('w_act_psHome_latest_blog_articles') }}
            </h2>

            <!-- Articles Carousel -->
            <div class="row py-0">
                <Carousel 
                    :autoplay="isClient ? 4000 : 0" 
                    :itemsToShow="slideItemsPerPage"
                    :transition="700"
                    :wrap-around="true"
                    snapAlign="start" 
                    v-model="activeSlide">
                    <Slide v-for="(article, _) in articles" :key="article.id" class="col-lg-4 mb-5 py-3">
                        <div class="px-3 d-flex flex-column h-100">
                            <img class="rounded-3 w-100 mb-4 cursor-pointer" :src="article.image" alt="Card image cap"
                                style="aspect-ratio: 16 / 9; height: 220px !important; object-fit: cover;" @click="navigate_to_article(article.path)" />
                            <div class="flex-grow-1">
                                <h4 class="cursor-pointer align-text-left" @click="navigate_to_article(article.path)">
                                    {{ article.title }}
                                </h4>
                                <p class="align-text-left sized-text">
                                    {{ article.description }} 
                                </p>
                                <small class="mt-2 article-date" style="font-size: 14px;" >
                                    <strong>{{ t('g_txt_published_on') }} {{ article.publish_date }}</strong>
                                </small>
                            </div>
                            
                        </div>
                    </Slide>
                </Carousel>
            </div>

            <div class="d-flex justify-content-center mt-0">
                <Link href="/blog/particuliers/" class="btn primary-btn text-white btn-text-visibility rounded px-5">
                {{ t('w_act_psHome_access_blog') }}
                </Link>
            </div>
        </div>
    </div>
</template>

<style scoped>
@import url('@/assets/css/bootstrap-extended.css');
@import url('@/assets/css/animate.css');
@import url('@/assets/css/main.css');
@import url('@/assets/css/responsive.css');

.sized-text {
    font-size: 16px !important;
}

.article-date {
    text-align: left !important;
    display: block;
}

.btn-text-visibility{
    font-size: 20px !important;
    font-weight: normal !important;
}

.primary-btn {
    background-color: #FEB23C !important;
    color: white;
    border-radius: 10px;
}

.align-text-left {
    text-align: left !important;
}

.carousel{
    padding: 0px !important;
}
</style>